<template>
    <v-btn
            :disabled="!available"
            icon
            @touchstart="redo"
            @click="redo">
        <v-icon>
            mdi-redo
        </v-icon>
    </v-btn>
</template>

<script>
    export default {
        name: "DrawingRedo",
        props: {
            available: {type: Boolean, default: false}
        },
        methods: {
            redo(e) {
                e.preventDefault()
                this.$emit('redo')
            }
        }
    }
</script>